<template>
  <div class="app-modal-dialog--learning-object-rearrangement-overlay app-modal-dialog">
    <div class="app-modal-dialog__content">
      <div class="app-modal-dialog__header">
        <h2 class="app-modal-dialog__title">
          <span class="app-modal-dialog__subtitle">{{ publication.name }}</span>
          Move Learning Object
        </h2>
        <button type="button" class="element-button--icon element-button" @click="$emit('cancel')" aria-label="Close">
          <svg class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
        </button>
      </div>
      <div class="app-modal-dialog__body grid">
        <p class="col-12">Select the "Move to" button to move the selected learning object to a different Topic.</p>
        <table class="col-12">
          <thead>
            <tr>
              <th>Title</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(topic, topicIndex) in topicSource" :key="topicIndex">
              <td class="app-modal-dialog__topic-name">
                <h3 class="app-modal-dialog__topic-name-text">
                  {{ topic.topicName }}
                </h3>
              </td>
              <td v-if="activeTopic == topicIndex" class="app-modal-dialog__lo-current-location">
                <div class="element-badge is--info">Current location</div>
              </td>
              <td v-else class="app-modal-dialog__lo-move-to">
                <app-button class="element-button element-button--secondary" @click="$emit('moveLearningObject', topicIndex, activeLearningObject?.id); $emit('cancel')">
                  Move To
                </app-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    publication: {
      type: Object,
    },
    topicSource: {
      type: Array,
      default: () => [],
    },
    activeTopic: {
      type: Number,
      default: null,
    },
    activeLearningObject: {
      type: Number,
      default: null,
    },
  },
}
</script>